import {
  LocationInterface,
  SessionDatesInterface,
  SessionsInterface,
} from '@app/interfaces/_index';

import { Sessions } from '../models/sessions.model';
import { Adapter } from './adapter';
import { LocationAdapter } from './location.adapter';
import { SessionDatesAdapter } from './session-dates.adapter';

/**
 * Adapts raw service from Docebo sessions object fields to a Sessions Model
 * NOTE: The item fields are the default json property names.
 */
export class SessionsAdapter implements Adapter<Sessions> {
  private sessionDatesAdapter: SessionDatesAdapter;
  private locationAdapter: LocationAdapter;

  constructor() {
    this.sessionDatesAdapter = new SessionDatesAdapter();
    this.locationAdapter = new LocationAdapter();
  }

  /**
   * Session Object response interface is used to display Sessison response from the DLP Lambdas
   * @param item has Session object response Session Interface
   * @returns - adapted session object to Session object model
   */
  adapt(item: SessionsInterface): Sessions {
    let sessions: Sessions;

    if (item) {
      sessions = new Sessions(
        item.id_session,
        item.name,
        item.description,
        item.start_date,
        item.end_date,
        item.max_enroll,
        item.enrolled && item.enrolled.count_enrolled,
        item.dates
          ? item.dates.map((field: SessionDatesInterface) => this.sessionDatesAdapter.adapt(field))
          : [],
        item.locations
          ? item.locations.map((field: LocationInterface) => this.locationAdapter.adapt(field))
          : [],
        item.last_subscription_date
      );
    }
    return sessions;
  }
}
